/* global axios */
import ApiClient from '../ApiClient';

class DealStatusAPI extends ApiClient {
  constructor() {
    super('pipeline/cards', { accountScoped: true });
  }

  markAsWon(itemId, { wonValue, wonNote, winningOfferIndex } = {}) {
    const payload = {};
    if (wonValue !== undefined && wonValue !== null && wonValue !== '') {
      payload.won_value = wonValue;
    }
    if (wonNote !== undefined && wonNote !== null && wonNote !== '') {
      payload.won_note = wonNote;
    }
    if (winningOfferIndex !== undefined && winningOfferIndex !== null) {
      payload.winning_offer_index = winningOfferIndex;
    }
    return axios.post(`${this.url}/${itemId}/deal_status/mark_won`, payload);
  }

  markAsLost(itemId, reason) {
    return axios.post(`${this.url}/${itemId}/deal_status/mark_lost`, {
      reason,
    });
  }

  reopen(itemId) {
    return axios.post(`${this.url}/${itemId}/deal_status/reopen`);
  }

  getLostReasonsAnalytics({ startDate, endDate } = {}) {
    const params = {};
    if (startDate) params.start_date = startDate;
    if (endDate) params.end_date = endDate;

    return axios.get(
      `${this.url.replace('/cards', '')}/deal_status/lost_reasons`,
      { params }
    );
  }

  getCommonReasons() {
    return axios.get(
      `${this.url.replace('/cards', '')}/deal_status/common_reasons`
    );
  }
}

export default new DealStatusAPI();
